import React, { useState, useContext } from 'react'
import { navigate } from 'gatsby';
import PropTypes from "prop-types"
import { ThemeProvider } from "styled-components"

import ConfigurationContext from '../../context/configuration-context';

import { THEME_GREY } from '../../theme/theme'

import { getLinkPropsFromMeta } from '../../utils/link'

import SectionContainer from '../section-container'

import { Inner, SummaryContainer, SummaryText, CategoriesContainer, CategoriesList, CategoriesListItem, CategoryLink, SearchContainer, SearchInput, SearchButton } from './blog-search-and-filter.styles'


const BlogSearchAndFilter = ({categories,overlap,searchPath,q,searchReady,numberResults}) => {
	const configuration = useContext(ConfigurationContext);
	
	const [input, setInput] = useState(q ? q : "");

	const handleInputChange = (e) => setInput(e.currentTarget.value)

	const handleSearchClick = () => navigate(`${searchPath}?q=${encodeURIComponent(input)}`)
	const handleSubmit = (event) => {
		event.preventDefault();
		navigate(`${searchPath}?q=${encodeURIComponent(input)}`)
	}

	const renderSide = () => {

		if(q){
			return (
				<SummaryContainer>
					{searchReady && <SummaryText>{`${numberResults > 0 ? configuration.label_search_results : configuration.label_no_search_results}${q ? ` "${q}"` : ``}`}</SummaryText>}
				</SummaryContainer>
			)
		}
		else if(categories){
			return (
				<CategoriesContainer>
					<CategoriesList>
						{categories.map((category,index) => (
							<CategoriesListItem key={index}>
								<CategoryLink {...getLinkPropsFromMeta(category._meta)}>{category.name}</CategoryLink>
							</CategoriesListItem>
						))}
					</CategoriesList>
				</CategoriesContainer>
			)
		}

		return null;
	}

	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer overlap={overlap} overlapSmall={overlap} condenseBottom>
				<Inner>
					{renderSide()}
					<SearchContainer onSubmit={handleSubmit}>
						<SearchInput value={input} type="text" placeholder={configuration.placeholder_search} onChange={handleInputChange} />
						<SearchButton filled onClick={handleSearchClick}>{configuration.label_search}</SearchButton>
					</SearchContainer>
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default BlogSearchAndFilter;